import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class VlabAvailability extends Component {
  #boundary;
  #revision = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#boundary = this.closest('product-card') || this.closest('.shopify-section, dialog');
    this.#boundary?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#boundary?.removeEventListener(StandardEvents.productSelect, this.#update);
    this.#boundary = undefined;
    this.#revision++;
  }

  #update = async (event) => {
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('product-card');
    if (card && card !== this.#boundary) return;
    const revision = ++this.#revision;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || revision !== this.#revision || !detail?.html) return;
      const productId = String(detail.newProduct?.id ?? detail.productId ?? this.dataset.productId);
      if (!detail.newProduct && productId !== this.dataset.productId) return;
      const source = Array.from(detail.html.querySelectorAll('vlab-availability')).find(
        (element) => element.dataset.productId === productId
      );
      this.dataset.productId = productId;
      if (!source) {
        this.hidden = true;
        return;
      }
      this.hidden = source.hidden;
      this.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[vlab-availability] Variant update failed:', error);
    }
  };
}

if (!customElements.get('vlab-availability')) customElements.define('vlab-availability', VlabAvailability);
